// extracted by mini-css-extract-plugin
module.exports = {"arrow":"lQ","dropMenu":"lR","dropMenuInner":"lS","itemborder":"lT","dropDownCurrent":"lU","menuItem":"lV","langContainer":"lW","current":"lX","outlink":"lY"};